import {Box, Stack, Typography} from "@mui/material";
import React from "react";
import {saraTheme} from "../theme/saraTheme";
import {Title} from "./Register/FormContent";

const CustomNavette = ({navettaId, viaggio}) => {
  const navetta = viaggio === "Andata" ? navette.andata[navettaId] : navette.ritorno[navettaId];
  return (navetta && <Stack>
      {/*<Box sx={{width: '100%', height: '0.07rem', background: saraTheme.palette.secondary.main}}/>*/}
      <Title title={`Navetta ${viaggio}`} />
      <Typography gutterBottom fontWeight={'bold'}>
        <u>{navetta.title}</u>
      </Typography>
      <Typography fontWeight={'bold'}>
        {navetta.partenza}
      </Typography>
      <Typography gutterBottom>
        {navetta.description}
      </Typography>
      {viaggio === "Ritorno" && <Box mt={4} sx={{width: '100%', height: '0.07rem', background: saraTheme.palette.secondary.main}}/>}
    </Stack>
  );
}

export default CustomNavette

const navette = {
  andata: {
    navettaSedeViaPo: {
      evento: 'Roma',
      title: "Sede Sara Via Po",
      partenza: "Partenza h 11:00",
      description: <>
        Una hostess ti attenderà con il cartello dell'evento presso l’uscita degli uffici Sara situati in Via PO’, 20.
        <br/><br/>
        Per ogni necessità puoi contattare <b>Castelli Benedetta</b> +39 388 2551 933
      </>,
    },
    navettaStazioneTermini1: {
      evento: 'Roma',
      title: "Stazione Termini",
      partenza: "Partenza h 11:00",
      description: <>
        Una hostess ti attenderà con il cartello dell'evento vicino le scale mobili -  uscita Via Giolitti - per raggiungere il punto di prelievo su <a href={"https://share.google/qMRoxtn5WqNzriv8n"} target={'_blank'}>Via Giolitti 48</a>.
        <br/><br/>
        Per ogni necessità puoi contattare:
        <br/><b>Troisi Martina</b> +39 334 1287 414 / <b>Dosi Michelle</b> +39 392 6317 369
      </>,
    },
    navettaStazioneTermini2: {
      evento: 'Roma',
      title: "Stazione Termini",
      partenza: "Partenza h 11:00",
      //partenza: "Partenza h 11:45", /** in caso dovesse tornare la seconda navetta navettaStazioneTermini2 */
      description:  <>
        Una hostess ti attenderà con il cartello dell'evento vicino le scale mobili -  uscita Via Giolitti - per raggiungere il punto di prelievo su <a href={"https://share.google/qMRoxtn5WqNzriv8n"} target={'_blank'}>Via Giolitti 48</a>.
        <br/><br/>
        Per ogni necessità puoi contattare:
        <br/><b>Troisi Martina</b> +39 334 1287 414 / <b>Dosi Michelle</b> +39 392 6317 369
      </>,
    },
    navettaAeroportoFiumicino1: {
      evento: 'Roma',
      title: "Aeroporto di Roma Fiumicino",
      partenza: "Partenza h 10:30",
      description: <>
        Una hostess ti attenderà con il cartello dell'evento presso l’uscita del terminal T3 - arrivi.
        <br/><br/>
        Per ogni necessità puoi contattare <b>Meddi Erica</b> +39 334 8438 198
      </>,
    },
    navettaAeroportoFiumicino2: {
      evento: 'Roma',
      title: "Aeroporto di Roma Fiumicino",
      partenza: "Partenza h 12:00",
      description: <>
        Una hostess ti attenderà con il cartello dell'evento presso l’uscita del terminal T3 - arrivi.
        <br/><br/>
        Per ogni necessità puoi contattare <b>Meddi Erica</b> +39 334 8438 198
      </>,
    },
    navettaStazioneMilanoCentrale: {
      evento: 'Milano',
      title: "Stazione di Milano Centrale",
      partenza: "Partenza h 11:30",
      description: <>
        Una hostess ti attenderà con il cartello dell'evento di fronte l’<a href={"https://maps.app.goo.gl/jwwnyTYmDf2Fduqf7"} target={'_blank'}>Hotel Gallia</a>.
        <br/><br/>
        Per ogni necessità puoi contattare:
        <br/><b>Melloni Francesca</b> +39 388 3442 519 / <b>Cinquini Veronica</b> +39 327 3779 581
        <br/><br/>
        Si prega di notare che i recapiti indicati saranno attivi <b>esclusivamente nella giornata dell'evento (17 febbraio)</b> per necessità relative alla navetta.
      </>,
    },
  },
  ritorno: { // TODO
    navettaSedeViaPo: {
      evento: 'Roma',
      title: "Sede Sara Via Po",
      description: "La partenza delle navette per il tragitto di ritorno è prevista al termine dei lavori.",
    },
    navettaStazioneTermini1: {
      evento: 'Roma',
      title: "Stazione Termini",
      description: "La partenza delle navette per il tragitto di ritorno è prevista al termine dei lavori.",
    },
    navettaStazioneTermini2: {
      evento: 'Roma',
      title: "Stazione Termini",
      description: "La partenza delle navette per il tragitto di ritorno è prevista al termine dei lavori.",
    },
    navettaAeroportoFiumicino1: {
      evento: 'Roma',
      title: "Aeroporto di Roma Fiumicino",
      description: "La partenza delle navette per il tragitto di ritorno è prevista al termine dei lavori.",
    },
    navettaAeroportoFiumicino2: {
      evento: 'Roma',
      title: "Aeroporto di Roma Fiumicino",
      description: "La partenza delle navette per il tragitto di ritorno è prevista al termine dei lavori.",
    },
    navettaStazioneMilanoCentrale: {
      evento: 'Milano',
      title: "Stazione di Milano Centrale",
      description: "La partenza delle navette per il tragitto di ritorno è prevista al termine dei lavori.",
    },
  }
}